// removed by extract-text-webpack-plugin
module.exports = {"patientTemplate":"_1GzARCt1kdm0LUsTcF3D-i","pageContainer":"A2ttdqJdD7lpPjq1CFCEe","sidebar":"Gb77BzZ8P4BW3O3NxaT0E","content":"_2E19S8hluUTaqWIAt6urVS"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PatientTemplate.scss
// module id = 559
// module chunks = 0